module.exports = __webpack_public_path__ + "static/media/2_menuE_86,35_3,7.8a4cdd9d.png";